<template>
  <div class="podcast-view">
    <div class="title-area flex-normal xpad">
        <div class="mtitle">
          <ix-router-link to="/news">More News</ix-router-link>
        </div>
        <div class="mtitle">
          <ix-router-link to="/podcasts">More Podcasts</ix-router-link>
        </div>
      </div>
    <div class="podcast-player">
      <div v-html="embedCode" class="ph-holder"></div>
    </div>
    <div class="podcast-flex">
      <div class="podcast-article">
        <div class="social-panel">
          <social-panel :url="url" :media="media" :message="message" :caption="news.title" />
        </div>
        <h1 v-html="news.title"></h1>
        <h2 v-html="news.summary"></h2>
        <div class="podcast-article-image">
          <img :src="imurl" class="maxfull" :alt="news.tile_alt" />
        </div>
        <div class="body" v-html="fbody" ref="pbody"></div>
      </div>
      <div class="podcast-right">
        <div class="podcast-subscribe">
          <div class="h4">Listen and subscribe</div>
          <div class="podcast-badges">
            <div v-if="soundcloudUrl" class="podcast-badge">
              <div class="pb-im">
                <a :href="soundcloudUrl" target="_blank">
                  <img src="../../assets/img/soundcloud.svg" alt="Soundcloud" >
                </a>
              </div>
              <div>Soundcloud</div>
            </div>
            <div v-if="appleUrl" class="podcast-badge">
              <div class="pb-im">
                <a :href="appleUrl" target="_blank">
                  <img src="../../assets/img/itunes.svg" alt="Apple iTunes" >
                </a>
              </div>
              <div>iTunes</div>
            </div>
          </div>
          
        </div>
        <div class="podcast-more">
          <div class="h4">Recent tracks</div>
          <podcast-panel v-for="item in articles" :key="item.news_id" :item="item" v-on:click="goStory(item)" small />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Trans from '@/utils/trans.js'
import newsHandler from '../news/news-handler.js'
import soundcloud from './soundcloud-format.js'
import SocialPanel from '@/components/panels/SocialPanel.vue'
import PodcastPanel from './PodcastPanel.vue'

const tg = 'podcast'
export default {
  components: {
    SocialPanel,
    PodcastPanel
  },
  props: {
    id: String
  },
  computed: {
    url () {
      if(this.news.news_id) {
        let ln = this.news.permalink.replace('/news/', '/podcasts/')
        return ln
      }
      return ''
    },
    media () {
      if(this.news.news_id){
        return this.getImageUrl(this.news.tile_image, '700')
      }
      return ''
    },
    soundcloudUrl () {
      return soundcloud.getSoundcloudUrl(this.news.podcast_url)
    },
    appleUrl () {
      return soundcloud.getAppleUrl(this.news.podcast_url)
    }
  },
  data () {
    return {
      news: {},
      picCount: 0,
      fbody: '',
      inpage: true,
      tags: [],
      message: 'Seen on IllustrationX',
      loaded: false,
      imloaded: false,
      extrapics: [],
      artist: null,
      embedCode: '',
      imurl: '',
      articles: []
    }
  },
  created () {
    this.loaded = false
    this.loadData()
  },
  methods: {
    getMatchingArtist (keys) {
      for(var item of keys) {
        let a = this.$store.getters.getMatchingArtist(item)
        if(a) return a
      }
      return null
    },
    getImageUrl(name, stype) {
      return newsHandler.getImageUrl(name, stype, this.news)
    },
    async loadData () {
      this.imloaded = false
      console.log('id', this.id)
      let res = await this.$apix.get(this.$k.getNewsUrl('news/byid/' + this.id + '/'))
      console.log('res', res)
      
      this.loaded = true
      this.news = res.data
      if(this.news.podcast_url) {
        this.embedCode = await soundcloud.getEmbedCode(this.news.podcast_url)
      }
      
      this.imurl = this.getImageUrl(this.news.tile_image, '900')
      let desc = this.$k.stripHtml(this.news.summary)
      if(this.inpage) {
        this.$k.setMetatags(this.news.title, desc)
        this.$k.setTwitterMetas(this.news.title, this.imurl, false, desc)
      }
      if(this.news.images) {
        this.picCount = this.news.images.length
      }
      else {
        this.picCount = 0
      }
      if(this.picCount > 1) {
        this.extrapics = this.news.images.slice(1)
      }
      let fbody = this.news.body.replace(/Calibri;/g, '')
      this.fbody = fbody
      
      let tags = this.news.tags.split('#')
      tags = tags.filter(el => el !== '')
      tags = Trans.convertTransArrayToObjects(tags)
      if(this.$store.getters.isNewsTranslatable) {
        await Trans.getTagTranslations(this.$apix, tags, this.$store.state.lang)
      }
      this.tags = tags
      this.$nextTick(() => {
        newsHandler.processImagesAndLinks(this.$refs.pbody, this.news)
      })
      if(this.news.tile_image){
         await this.$k.loadImage(this.getImageUrl(this.news.tile_image, '900'))
      }
      this.imloaded = true
      this.$emit('load', this.news)
      await this.$store.dispatch('fetchArtists')
      this.artist = this.getMatchingArtist(this.news.tags.split('#'))
      window.setTimeout(this.loadRelated, 500)

    },
    async loadRelated () {
      let url = this.$k.getNewsUrl(`news/bytag/${tg}/`)
      let res = await this.$apix.get(url)
      res = res.data.slice(0, 5)
      res = res.filter(el => el.news_id !== this.news.news_id)
      this.articles = res
    }

  },
  watch: {
    id () {
      this.loadData()
    }
  }
}
</script>

<style>
.podcast-view .mtitle{
  font-size:24px;
  line-height:28px;
  margin-right:30px;
}

.podcast-view .podcast-article{
  margin-top:30px;
  max-width:700px;
}

.podcast-article .social-panel{
  margin-bottom:50px;
}

.podcast-article h1{
  font-size:24px;
  color:#ce0e2d;
}

.podcast-article h2{
  font-size:24px;
  color:#000;
}

.podcast-article a{
  color:#8b6f4b;
}

.podcast-article a:hover{
  color:#ce0e2d;
}



.podcast-article .body{
  font-size:18px;
  line-height:24px;
}

.podcast-view .flex-normal{
  display:flex;
  align-items: center;
  justify-content: flex-start;
}
.podcast-view .xpad{
  margin-bottom:30px;
}
.podcast-player{
  background-color:#fff;
  border-radius:6px;
  padding:30px;
  border:1px solid #bbb;
  min-height:166px;
}

.podcast-badges{
  display:flex;
  align-items:center;
}

.podcast-article-image {
  width:100%;
  position:relative;
  margin-bottom:20px;
}

.podcast-flex{
  display:flex;
  justify-content:space-between;
}

.podcast-right{
  max-width:420px;
  margin-left:20px;
}

.podcast-more .podcast-holder{
  width:100%;
  margin-bottom:20px;
}

.maxfull {
  max-width:100%;
}

.podcast-badge{
  max-width:120px;
  text-align:center;
  font-size:12px;
  opacity:0.7;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.1s linear;
  height:50px;
  margin-right:20px;
}

.podcast-badge:hover{
  opacity:1;
}

.podcast-badge .pb-im{
  display:flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}

.podcast-badge img{
  width:30px;
}

.podcast-subscribe{
  background-color:#fff;
  border-radius:6px;
  padding:20px;
  border:1px solid #bbb;
  margin-top:30px;
  width:420px;
  box-sizing:border-box;
}

.podcast-subscribe .h4{
  margin:0 0 16px 0;
}

@media screen and (max-width:1024px){
  .podcast-flex{
    display:block;
  }

  .podcast-view .podcast-article{
    max-width:100%;
  }

  .podcast-right{
    max-width:100%;
    margin-left:0;
    margin-right:0;
  }

  .podcast-subscribe{
    width:100%;
  }
}
</style>